import { I18n } from "./types";

export const i18n: I18n = {
  es: {
    appTitle: "Comunidad Catolica El Salvador Del Mundo",
    appDescription: "Sistema De Inscripción",
    appSlogan: "Unidos en fe y servicio a nuestra comunidad.",
    logout: "Cerrar Sesión",
    loginTitle: "Bienvenido/a",
    username: "Correo electronico",
    password: "Contraseña",
    loginButton: "Continuar",
    emptyUserMessage: "Debe Agregar Usuario y/o Correo",
    emptyPasswordMessage: "Debe Agregar Contraseña",
    footer: "Comunidad Catolica El Salvador Del Mundo © 2024",
    genericErrorMessage: "Ha ocurrido un error inesperado",
    header: {
      navmenu: {
        groups: "Grupos",
        events: "Retiros",
        participants: "Participantes",
        servers: "Servidores",
        auth: "Seguridad",
        meetings: "Asambleas"
      }
    }
  },
  en: {
    appTitle: "COMU",
    appDescription: "Community Management System",
    appSlogan: "United in faith and service to our community.",
    logout: "Logout",
    loginTitle: "Welcome",
    username: "Username",
    password: "Password",
    loginButton: "Login",
    footer: "Comunidad Catolica El Salvador Del Mundo © 2024",
    emptyUserMessage: "Please enter a valid email address",
    emptyPasswordMessage: "Please enter a valid password",
    genericErrorMessage: "An unexpected error has ocurred",
    header: {
      navmenu: {
        groups: "Groups",
        events: "Events",
        participants: "Participants",
        servers: "Servers",
        auth: "Security",
        meetings: "Meetings"
      }
    }
  }
};
